import React from "react";
import AceEditor from "react-ace";
import Wrapper from "../Wrapper";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-terminal";
import "ace-builds/src-noconflict/theme-monokai";

export default React.forwardRef((props, ref) => {
    return (
        <Wrapper className="hms-code-editor">
            <AceEditor
                {...props}
                mode={props.mode || 'html'}
                theme={props.theme || 'github'}
                ref={ref}
                fontSize={14}
                width={'100%'}
                height={props.height || 'unset !important'}
                showPrintMargin={true}
                highlightActiveLine={false}
                showGutter={true}
                setOptions={{
                    ...(props.setOptions || {}),
                    enableBasicAutocompletion: true,
                    showLineNumbers: true,
                    tabSize: 2,
                }}
            />
        </Wrapper>
    )
});